/**
 * PRICING MONEY UTILS
 * Conversions euros <-> centimes pour la grille tarifaire (pricing_items).
 * Les montants sont stockés en CENTIMES en DB, saisis/affichés en euros.
 */

export function eurosToCents(euros: number): number {
  return Math.round(euros * 100);
}

export function centsToEuros(cents: number): number {
  return cents / 100;
}

export function formatCentsToEuros(cents: number): string {
  return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(cents / 100);
}
